import { Action } from 'redux';
import { IBackgroundJobInfo } from '../../../backgroundJob/types/BackgroundJobs';
import { OpenCancelBackgroundJobDialog } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface OpenCancelBackgroundJobDialogAction extends Action {
    backgroundJob: IBackgroundJobInfo;
}

export function openCancelBackgroundJobDialogAction(backgroundJob: IBackgroundJobInfo): OpenCancelBackgroundJobDialogAction {
    return {
      type: OpenCancelBackgroundJobDialog,
      backgroundJob,
    };
  }

export const isOpenCancelBackgroundJobDialogAction = isActionFactory<OpenCancelBackgroundJobDialogAction>(OpenCancelBackgroundJobDialog);
